// Limiti priloga dijele server (BugReportService) i dijalog za prijavu —
// browser odbija iste fajlove prije slanja da korisnik ne čeka upload uzalud.

export const MAX_ATTACHMENTS = 5;
export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;
export const MAX_VIDEO_BYTES = 50 * 1024 * 1024;
export const MAX_TOTAL_BYTES = 100 * 1024 * 1024;

export const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];
export const VIDEO_TYPES = ["video/mp4", "video/webm", "video/quicktime"];

export type AttachmentLike = { name: string; size: number; type: string };

export function isImageType(type: string): boolean {
  return IMAGE_TYPES.includes(type);
}

export function isVideoType(type: string): boolean {
  return VIDEO_TYPES.includes(type);
}

/** Vraća prvu grešku (na bosanskom) ili null ako je lista ispravna. */
export function validateAttachmentList(files: AttachmentLike[]): string | null {
  if (files.length > MAX_ATTACHMENTS) return `Najviše ${MAX_ATTACHMENTS} priloga po prijavi`;

  let total = 0;
  for (const f of files) {
    if (isImageType(f.type)) {
      if (f.size > MAX_IMAGE_BYTES) return `Slika ${f.name} je veća od 10MB`;
    } else if (isVideoType(f.type)) {
      if (f.size > MAX_VIDEO_BYTES) return `Video ${f.name} je veći od 50MB`;
    } else {
      return `Nepodržan tip fajla: ${f.name}`;
    }
    total += f.size;
  }
  if (total > MAX_TOTAL_BYTES) return "Ukupna veličina priloga je veća od 100MB";
  return null;
}
